import Breadcrumb from "Components/Common/Breadcrumb";
import React from "react";
import { Container } from "reactstrap";

function Suscriptions() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Suscriptions" breadcrumbItem="Suscriptions" />
          <h4>Suscriptions</h4>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Suscriptions;
